import { MULTI_CART_DATA } from '@spartacus/cart/base/core'
import { CartModificationList } from '@spartacus/cart/base/root'
import { StateUtils } from '@spartacus/core'

export const EB_CART_UPLOAD_CSV = '[Eb-cart-upload] Add Entries Fail'
export const EB_CART_UPLOAD_CSV_SUCCESS = '[Eb-cart-upload] Upload Csv-File Success'
export const EB_CART_UPLOAD_CSV_FAIL = '[Eb-cart-upload] Upload Csv-File Fail'

export class EbCartCsvUpload extends StateUtils.EntityProcessesIncrementAction {
  readonly type = EB_CART_UPLOAD_CSV

  constructor(
    public payload: {
      cartId: string
      userId: string
      formData: FormData
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export class EbCartCsvUploadSuccess extends StateUtils.EntityProcessesDecrementAction {
  readonly type = EB_CART_UPLOAD_CSV_SUCCESS

  constructor(
    public payload: {
      cartId: string
      cartModification: CartModificationList
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export class EbCartCsvUploadFail extends StateUtils.EntityProcessesDecrementAction {
  readonly type = EB_CART_UPLOAD_CSV_FAIL

  constructor(
    public payload: {
      cartId: string
      error: any
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export type EbCartAction = EbCartCsvUpload | EbCartCsvUploadFail | EbCartCsvUploadSuccess
